import api from 'Application/api/api';

const moveTemplateGroupUp = (id, cancelToken = null) =>
    api.post(`project-manager/template-groups/${id}/move-up`, {
        cancelToken,
    });

export default moveTemplateGroupUp;
